import type { ModalFuncProps } from 'antd';
import modalConfirm            from './modalConfirm';

export default (options: ModalFuncProps) => {
  modalConfirm({
    className: 'project-confirm-modal delete',
    maskClosable: true,
    okText: `Supprimer`,
    okType: 'danger',
    title: `Supprimer ?`,

    ...options,
  });
};
